import React, { useEffect, useRef, useState } from "react";
import { Splide, SplideTrack, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css/core";
import introImg from "../../images/info-green.svg";

import { StatsCard } from "../global/StatsCard";
import { MobileNavigation } from "../global/MobileNavigation";
import io from "socket.io-client2";

export const Numbers = ({ stats = [], color = "pink", isFront = false }) => {
  let defaultStats = JSON.parse(JSON.stringify(stats));

  defaultStats.map((item) => {
    switch (item.value) {
      case "netHashrate":
        item.value = "157 Ehs";
        break;
      case "activeAccounts":
        item.value = "72,000";
        break;
      case "blocked":
        item.value = "3,539 RBTC";
        break;
      case "blockTime":
        item.value = "29.10";
        break;
      case "mergedMining":
        item.value = "85%";
        break;
      case "avgTxCost":
        item.value = "0.15c";
        break;
      case "monthlyTxs":
        item.value = "68,400";
        break;
    }
    return item;
  });

  const [numbers, setNumbers] = useState(defaultStats);
  const sliderRef = useRef(null);
  const [totalSlides, setTotalSlides] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(1);

  useEffect(() => {
    let timerId = null;

    const socket = io("wss://be.explorer.rootstock.io", {
      transports: ["websocket"],
    });

    socket.on("connect_error", (err) => {
      console.log(`connect_error due to ${err.message}`);
    });

    socket.on("connect", () => {
      const payload = {
        module: "stats",
        action: "getStats",
        params: {},
      };

      socket.emit("data", payload);

      timerId = setInterval(() => {
        socket.emit("data", payload);
      }, 2000);
    });

    socket.on("disconnect", () => {
      clearInterval(timerId);
    });

    socket.on("close", () => {
      clearInterval(timerId);
    });

    socket.on("data", (res) => {
      const data = res.data || [];
      if (data?.length > 0) {
        let activeAcc = data[0]?.activeAccounts || 70037;
        activeAcc = activeAcc.toLocaleString("en-US");

        let blocked = data[0]?.circulating?.circulatingSupply || 3246;
        blocked = (+(+blocked).toFixed(0)).toLocaleString("en-US");
        blocked = `${blocked} RBTC`;

        let hashrate = data[0]?.hashrate || 110;
        hashrate = (hashrate / 1000000000000000000).toFixed(0);
        hashrate = `${hashrate} Ehs`;

        stats.map((item, index) => {
          switch (item.value) {
            case "netHashrate":
              numbers[index].value = hashrate;
              break;
            case "activeAccounts":
              numbers[index].value = activeAcc;
              break;
            case "blocked":
              numbers[index].value = blocked;
              break;
          }
          return item;
        });
        setNumbers([...numbers]);
      }
    });

    socket.on("subscription", (res) => {
      console.log(`Subscription to ${res.channel} was successfully`);
    });

    return () => {
      socket.close();
      clearInterval(timerId);
    };
  }, []);

  // Fetch Monthly Transactions
  useEffect(() => {
    fetch("https://be.explorer.rootstock.io/api?module=transactions&action=getTransactionsCount")
      .then((response) => response.json())
      .then((data) => {
        let monthlyTxs = data?.data?.transactionsCountLast30Days || 240424;  // Default fallback value
        monthlyTxs = monthlyTxs.toLocaleString("en-US");

        stats.map((item, index) => {
          if (item.value === "monthlyTxs") {
            numbers[index].value = monthlyTxs;
          }
          return item;
        });

        setNumbers([...numbers]);
      })
      .catch((error) => console.log(error));
  }, []);

  // Fetch Merged Mining Percentage
  useEffect(() => {
    const ws = new WebSocket(
      "wss://backend.stats.rsk.co/primus/?_primuscb=1684354028786-0" // mainnet WebSocket
    );

    ws.onerror = (error) => console.error("WebSocket Error: ", error);

    ws.onopen = function () {
      console.log("WebSocket connection opened for merged mining data.");
      ws.send("ready");
    };

    ws.onmessage = function (msg) {
      try {
        const msgObject = JSON.parse(msg.data);

        console.log("Received WebSocket Data:", msgObject); // Debugging logs

        if (msgObject.action === "charts") {
          if (msgObject.data && msgObject.data.hashrateComparedToBtcNetwork !== undefined) {
            let mergedMining = +msgObject.data.hashrateComparedToBtcNetwork || 85;
            mergedMining = mergedMining.toFixed(0) + "%";

            stats.map((item, index) => {
              if (item.value === "mergedMining") {
                numbers[index].value = mergedMining;
              }
              return item;
            });

            console.log("Updated merged mining value:", mergedMining); // Debugging logs
            setNumbers([...numbers]);
          } else {
            console.warn("Merged mining data field is missing in the WebSocket response.");
          }
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    return () => {
      ws.close(1000, "Complete");
      console.log("WebSocket connection closed.");
    };
  }, []);

  useEffect(() => {
    if (sliderRef.current) {
      setTotalSlides(sliderRef.current.splide.length);
    }
  }, []);

  const renderStats = (color = "pink") => {
    return numbers.map((card, index) => (
      <SplideSlide key={index}>
        <StatsCard
          title={card.title}
          qty={card.value}
          label={card.label}
          color={color}
          source={card.source}
          image={card.image}
        />
      </SplideSlide>
    ));
  };

  return isFront ? (
    <div className="d-flex align-items-md-center justify-content-between flex-wrap flex-column flex-md-row">
      {numbers.map((item, index) => (
        <div
          className="d-inline-flex letter-spacing-1 flex-column mb-lg-0 mb-md-6 mb-4"
          key={index}
        >
          <div className="d-flex mb-3 align-items-start">
            <span className={`bg-${color} fs-7 p-2 text-black align-self-start`}>
              {item.title}
            </span>
          </div>

          <span className="fw-bolder fs-4">
            {item.value}
            <div className="tooltip">
              <img
                src={introImg}
                className="info-img"
                alt="Ambassador"
                width="25"
                height="25"
                loading="lazy"
              />
              <span className="tooltiptext">
                <p className="mb-0 mt-2" dangerouslySetInnerHTML={{ __html: item.source }}></p>
              </span>
            </div>
          </span>
        </div>
      ))}
    </div>
  ) : null;
};